export default {
  kyc_i_agree: 'I confirm that I have read, consent and agree to CryptoPort <a @click.stop.prevent>User Agreement</a> and <a @click.stop.prevent>Privacy Policy</a>,\nand I am of legal age.',
  kyc_account_verification: 'Account verification',
  kyc_data_processed: 'Your data is being processed.',
  kyc_address_details: 'Address details',
  kyc_document_not_attached: 'document not attached',
  kyc_required_documents: 'Required documents',
  kyc_photo_verification: 'Photo verification',
  kyc_photo_explain: `To be sure it's you who submits the documents, please make a photo with a unique generated key`,
  kyc_show_key: 'Show the key',
  kyc_verification_key: 'Verification key',
  kyc_not_all_docs: 'Please upload all the documents before submit',
  kyc_upload_success: 'Information uploaded. Now please wait for approval',
  kyc_current_account_state: 'Current account state',
  kyc_approved_msg: 'Your account is approved. All actions that require verification are now available',
  kyc_approved_syndicate: 'Your account is approved, you are corporate user. All actions that require verification are now available',
  kyc_waiting_msg: `Your verification request is submitted. Please wait until we review the information.
                    You will be able to update details once the request is reviewed`,
  kyc_rejected_msg: 'Unfortunately, your account was rejected with reason: %{reason}',
  kyc_personal_details: 'Personal details',
  kyc_corporate_details: 'Corporate details',
  kyc_documents: 'Documents',
  kyc_approved_title: 'Account approved.<br/>You are registered as a %{account_type} user.',
  kyc_update: 'UPDATE KYC DATA',
  kyc_general: 'General',
  kyc_submit: 'Submit KYC',
  kyc_pass: 'Pass KYC check',
  kyc_check_status: 'Check Verification Status',
  kyc_corporate: 'Corporate',
  kyc_inv_tip: 'Can invest in funds',
  kyc_corporate_tip: 'Can create funds',
  kyc_rejected_title: 'Your verification request is rejected',
  kyc_rejected_msg_html: 'Unfortunately, your account was rejected with reason: <span class="reject-message">%{reason}</span>',
  kyc_not_privacy_policy: 'Please accept the Privacy policy before submit',
  kyc_form_submit: 'KYC form submission',
  kyc_general_company_information: 'Company general information',
  kyc_company_legal_address: 'Company legal address',
  kyc_business_model: 'Business model',
  kyc_company_documents: 'Company\'s documents',
  kyc_company_directors: 'Directors and shareholders',
  kyc_residence_address: 'Residence address details',
  kyc_address_proof: 'Proof of address document',
  kyc_submit_company_documents: 'Submit the company\'s documents',
  kyc_upload_memorandium: 'Upload a photocopy of Memorandium & Articles of Association',
  kyc_upload_signatories: 'Upload a photocopy of the authorization of the signatories of the company',
  kyc_upload_chart: 'Upload a file with the company organization chart',
  kyc_upload_address: 'Upload a photocopy of the proof of address document',
  kyc_upload_id: 'Upload a photocopy of the identity document',
  kyc_upload_certificate_of_shareholders: 'Upload a photocopy of the Certificate of shareholders and directors',
  kyc_upload_annual_report: 'Upload a photocopy of the latest company annual report',
  kyc_upload_origination_certificate: 'Upload a photocopy of the Certificate of incorporation',
  kyc_company_industry: 'Industry of the company',
  kyc_company_website: 'Company website',
  kyc_company_phone: 'Company phone number',
  kyc_corp_step1_subhead: 'All documents except the description of the business model, the company organization chart and the company website must be certified (Notarized) by an official of integrity appointed by the local government to serve the public as an impartial witness in performing a variety of official fraud-deterrent acts related to the signing of important documents.',
  kyc_submit_legal_address: 'Please, submit the following legal address information',
  kyc_upload_audited_copy: 'Upload the audited copy if possible. If this is not available then the most recent company bank statement can be uploaded. A bank statement will be required for all companies that have been trading for less than 12 months. For larger companies, previous 3 years tax returns are needed.',
  kyc_submit_full_kyc_docs: 'Submit the the full KYC documents for all company directors and shareholders (if different and holding over 10% interest)',
  kyc_submit_docs: 'Submit the company\'s documents',
  kyc_submit_residence_address: 'Please, submit the following residence address information',
  kyc_upload_address_proof: 'Please, upload a proof of address document',
  kyc_upload_business_model: 'Upload a file with the description of the business model',
  kyc_submit_personal_information: 'Please, submit the following personal information',
  kyc_upload_one_of_docs: 'Please, upload one of the documents:',
  kyc_upload_document_photo: 'Upload the document photo',
  kyc_id_docs_tip: 'In all cases handwritten documents or those in a foreign script that cannot be read, i.e Arabic or Cyrillic will not be accepted unless translated and notarized.',
  kyc_driver_license: 'Driving license if not already uploaded on the previous step',
  kyc_utility_bill: 'Recent utility bill (not older than 6 months old)',
  kyc_bank_statement: 'Bank statement or credit card statement (not older than 6 months)',
  kyc_bank_reference_letter: 'Bank reference letter (not older than 6 months)',
  kyc_signed_tenancy: 'Signed Tenancy/Rental Agreement',
  kyc_valid_passport: 'Valid passport',
  kyc_driving_license: 'Driving license - full, not provisional, with a color photograph',
  kyc_national_id: 'Valid National ID card',
  kyc_copy_passport: 'Notarized copy of the valid passport with a picture',
  kyc_copy_driver_license: 'Notarized copy of the driving license with a picture',
  kyc_copy_national_id: 'Notarized copy of the valid National ID card with a picture',
  kyc_corporate_copy_current_tax: 'Notarized copy of the current tax returns within current 12 months',
  kyc_corporate_copy_bank_statement: 'Notarized copy of bank statement or credit card statement (not older than 3 months)',
  kyc_corporate_copy_utility_bill: 'Notarized copy of Utility bill (not older than 3 months)',
  kyc_submit_document: 'Please, submit the following document',
  kyc_document_details: 'Document details',

  verif_investor: 'Investor',
  verif_issuer: 'Issuer',
  verif_description_step1_issuer: 'Подойдёт вам, если вы хотите создавать собственные проекты, которые нуждаются в инвестировании',
  verif_description_step1_investor: 'Подойдёт вам, если вы хотите инвестировать и получать доход',
  verif_description_step2: 'DIT не хранит ваши персональные данные — они хранятся на серверах нашего партнёра Sumsub, которые надёжно защищены',
  verif_step3_title: 'Мы верифицировали ваши данные, вам осталось только подтвердить тип аккаунта',
  verif_your_acc: 'Ваш тип аккаунта — ',
  verif_step3_descritption: 'После подтверждения вы не сможете поменять тип аккаунта. Если передумали — выберите другой тип и пройдите верификацию заново.',
  verif_change_acc: 'Сменить тип аккаунта',
  verif_success_investor_title: 'Отлично, мы подтвердили ваш аккаунт инвестора',
  verif_success_issuer_title: 'Отлично, мы подтвердили ваш аккаунт эмитента',
  verif_success_investor_subtitle: 'Теперь вы можете пополнять счёт, инвестировать в проекты и получать дивиденды',
  verif_success_issuer_subtitle: 'Теперь вы можете создавать проекты, получать инвестиции и выплачивать дивиденды инвесторам',
  verif_success_investor_text: 'Давайте поищем интересные проекты для инвестиции — наверняка вы найдете что-то по душе',
  verif_success_issuer_text: 'Уже есть идея для проета? Так чего же мы ждём, давайте создадим ваш первый проект!'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/verification_view.js